/*
* Mobile menue
*/
function mobileMenu() {
    document.addEventListener('DOMContentLoaded', () => {
        const metaNav = document.getElementById('meta-nav');
        const mainNav = document.getElementById('navbarNavDropdown');
        const offcanvasBody = document.querySelector('.offcanvas-body');

        //Mobile menue: Activate mobile menu
        function activateMobileMenu() {
            const menuRightElem = document.getElementById('navbarNavDropdown');
            const menuRight = new SlideMenu(menuRightElem, {
                // https://github.com/grubersjoe/slide-menu
                showBackLink: true
            });
            removeBackButton()
        }

        function enquireWindow() {
            enquire.register('screen and (max-width: 889px)', {
                match: function () {
                    // Move metanav to offcanvas menu
                    // offcanvasBody.appendChild(metaNav);
                    // Mobile menu: Remove classes from boostrap desktop menue
                    mainNav.className = "slide-menu";
                    mainNav.querySelectorAll("ul").forEach((ul) => {
                        ul.classList.remove("dropdown-menu");
                    });
                    addParentCategoryLinkAboveMenu();
                    activateMobileMenu();
                }, unmatch: function () {
                    // Reset all classes and elements for desktop view
                    window.location.reload();
                }
            })
            enquire.register('screen and (min-width: 890px)', {
                match: function () {
                    // Desktop menu: Call function for hover animation on desktop
                    desktopMenuHoverAnimation();
                }
            })
        }
        enquireWindow();
    })
}
mobileMenu();

/*
* Mobile menue: Remove back button if first level is shown in navigation
*/
function removeBackButton() {
    const backButton = document.querySelector('#backbutton');
    const slider = document.querySelector('.slide-menu__slider');
    const metaNav = document.getElementById('meta-nav');

    // Show and hide back button after navigate. Inital it has 'display:none' as inline style in php
    if (slider && backButton) {
        slider.addEventListener('transitionend', () => {
            if (slider.style.transform.includes('translateX(0%)')) {
                backButton.style.display = 'none';
                metaNav.style.display = 'block';
            } else {
                backButton.style.display = 'block';
                metaNav.style.display = 'none';
            }
        });
    }
    // Remove slide back functionality from back link. We only need it as headline.
    document.querySelectorAll('a.slide-menu__backlink').forEach(function (element) {
        element.removeAttribute('data-action');
    });

}


/*
* Desktop: Mega menu flyout animation with backdrop
*/
function desktopMenuHoverAnimation() {
    document.querySelectorAll('#main-menu > li.dropdown').forEach((li) => {
        li.addEventListener('mouseover', () => {
            document.querySelector('.main-menu-backdrop').classList.add('show');
        });
        li.addEventListener('touchstart', () => {
            document.querySelector('.main-menu-backdrop').classList.add('show');
        });
        li.addEventListener('mouseout', () => {
            document.querySelector('.main-menu-backdrop').classList.remove('show');
        });
    });
}


function primeLogo() {
    const primeState = document.getElementById('prime-state');
    if (primeState) {
        const mediaElement = document.querySelector('#content > div .wp-block-media-text__media');
        const contentDiv = document.querySelector('#content > div');
        enquire.register('screen and (min-width: 992px)', {
            match: function () {
                if (primeState && mediaElement) {
                    mediaElement.appendChild(primeState);
                }
            }, unmatch: function () {

            }
        })
        enquire.register('screen and (max-width: 991px)', {
            match: function () {
                contentDiv.parentNode.insertBefore(primeState, contentDiv.nextSibling);
            }, unmatch: function () {

            }
        })
    }
}

primeLogo()


// Preparation for tooltips. Works only with jQuery?
// function setTooltips() {
//     jQuery(function () {
//         jQuery('[data-toggle="tooltip"]').tooltip()
//     })
// }
// setTooltips();


function tabs() {
// I got help from the origin plugin developer regarding not working tabs.
// https://wordpress.org/support/topic/block-tabs-doesnt-work-as-expected/#post-18240753
// https://youtrack.iwelt.de/issue/WMR24-148/Content-Element-Tabs

    jQuery(document).ready(function ($) {
        $('.areoi-tabs').each(function () {
            var active = $(this).find('.nav a.active:first-of-type');
            $(this).find('.nav a.active:not(:first-of-type)').removeClass('active');
            $(this).find('> div').addClass('tab-pane d-none');
            var active_tab = $(this).find(active.attr('href'));
            if (active_tab) {
                active_tab.removeClass('d-none');
            }
        });

        $(document).on('click', '.areoi-tabs .nav a', function (e) {
            var href = $(this).attr('href');
            if (href && href.startsWith('#')) {
                e.preventDefault();

                var container = $(this).parents('.areoi-tabs');
                var active_tab = container.find($(this).attr('href'));

                container.find('.nav a').removeClass('active');
                $(this).addClass('active');

                if (active_tab) {
                    container.find('> div').addClass('d-none');
                    active_tab.removeClass('d-none');
                }
            }
        });
    });
}

tabs()

// Headline pages have no valid href, these are custom links in menu.
// But I think it's better to deactivate the behaviour additionally.
// Especially since this was already finished before the menu pages were redesigned ;)

function unlinkFlyoutMenuHeaders() {
    document.querySelectorAll('.level-1 > li.menu-item-has-children > a').forEach(link => {
        link.addEventListener('click', event => {
            event.preventDefault();
        });
    });
}

// unlinkFlyoutMenuHeaders()


function addParentCategoryLinkAboveMenu() {
    document.querySelectorAll('.menu-item-has-children > a').forEach(function (link) {
        // Clone the link
        const clonedLink = link.cloneNode(true);

        // Create a text node with "gehe zu"
        const textNode = document.createTextNode('Zur Seite ');

        // Prepend the text node to the cloned link
        clonedLink.insertBefore(textNode, clonedLink.firstChild);

        // Find the next <ul> sibling
        const nextUl = link.nextElementSibling;

        if (nextUl && nextUl.tagName === 'UL') {
            // Create a new list item
            const listItem = document.createElement('li');

            const firstli = document.createElement('li');
            firstli.className = 'boeuse';
            firstli.setAttribute('tabindex', '99999'); // Add tabindex attribute


            listItem.className = 'parent-category-link';

            // Append the cloned link to the list item
            listItem.appendChild(clonedLink);
            // Prepend the list item to the next <ul>
            nextUl.insertBefore(listItem, nextUl.firstChild);
            nextUl.insertBefore(firstli, nextUl.firstChild);
        }
    });
}


